import React from 'react';
import type { ScanProgress } from '../../hooks/useScanResults';

interface ProgressBarProps {
  progress: ScanProgress;
}

export function ProgressBar({ progress }: ProgressBarProps) {
  console.log(`[ProgressBar] Rendering progress: ${progress.progress}% - ${progress.message}`);
  
  const getStageColor = (stage: string) => {
    switch (stage) {
      case 'initializing':
        return 'bg-blue-500';
      case 'scanning':
        return 'bg-yellow-500';
      case 'analyzing':
        return 'bg-purple-500';
      case 'completed':
        return 'bg-green-500';
      default:
        return 'bg-gray-500';
    }
  };

  const getStageIcon = (stage: string) => {
    switch (stage) {
      case 'initializing':
        return '🔄';
      case 'scanning':
        return '🔍';
      case 'analyzing':
        return '🧠';
      case 'completed':
        return '✅';
      default:
        return '⏳';
    }
  };

  return (
    <div className="bg-gray-900 rounded-lg p-6 border border-gray-800">
      <div className="flex items-center space-x-3 mb-4">
        <span className="text-2xl">{getStageIcon(progress.stage)}</span>
        <h3 className="text-lg font-semibold text-white capitalize">
          {progress.stage} Scan
        </h3>
      </div>

      {/* Progress Bar */}
      <div className="mb-4">
        <div className="flex justify-between text-sm text-gray-400 mb-2">
          <span>{progress.message}</span>
          <span>{progress.progress}%</span>
        </div>
        <div className="w-full bg-gray-800 rounded-full h-3">
          <div 
            className={`h-3 rounded-full transition-all duration-300 ${getStageColor(progress.stage)}`}
            style={{ width: `${progress.progress}%` }}
          />
        </div>
      </div>

      {/* Scanner Progress */}
      {progress.stage === 'scanning' && progress.totalScanners > 0 && (
        <div className="space-y-2">
          <div className="text-sm text-gray-400">
            Scanner Progress ({progress.completedScanners.length}/{progress.totalScanners})
          </div>
          <div className="grid grid-cols-3 gap-2">
            {Array.from({ length: progress.totalScanners }).map((_, index) => (
              <div 
                key={index}
                className={`h-2 rounded-full ${
                  index < progress.completedScanners.length 
                    ? 'bg-green-500' 
                    : index === progress.completedScanners.length 
                      ? 'bg-yellow-500 animate-pulse' 
                      : 'bg-gray-700'
                }`}
              />
            ))}
          </div>
          {progress.currentScanner && (
            <div className="text-sm text-yellow-400 mt-2">
              ⚡ {progress.currentScanner}
            </div>
          )}
        </div>
      )}
    </div>
  );
} 